// @flow

import { call, fork, put, take } from 'redux-saga/effects'
import { GET_MEMBERS_BY_LEAGUE_ID, getMembersListByLeagueId } from 'src/redux/actions/members/members'
import http from 'src/services/http'
// types
import type { IOEffect } from 'redux-saga/effects'

function * watchGetMembersListByLeagueId(): Generator<IOEffect, void, any> {
  while (true) {
    const {
      payload: { league_id },
    } = yield take(GET_MEMBERS_BY_LEAGUE_ID.REQUEST)
    try {
      const { data } = yield call(http, `api/league/members/${league_id}`, {
        method: 'GET',
      })

      yield put(getMembersListByLeagueId.success(data))
    } catch (e) {
      yield put(getMembersListByLeagueId.error(e.message))
    }
  }
}

export default [fork(watchGetMembersListByLeagueId)]
